const ExpandToAddOrEdit = ({ startingValue, setStartCollapsedState }) => {
    return <span className={"unselectable"} style={{ cursor: "pointer" }}
        onClick={() => { setStartCollapsedState(false) }}>
        {startingValue ? <>✎ Edit</> : <>➕ Add</>}
    </span>
};

export default ExpandToAddOrEdit;